<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          리셀러 관리 (등록 리셀러 수: {{ addCommaToNumber(listSize) }})
        </h3>
        <span class="pageDesc">
          리셀러를 등록하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center;">
        <button
          class="btn btn-primary"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#resellerInfoWModal"
        >
          등록하기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox">
        <select v-model="deleteFilter"
        id="itemCode"
        @change="enter()"
        >
          <option value="" selected>전체</option>
          <option value="N">삭제 안된 리셀러만</option>
          <option value="Y">삭제된 리셀러만</option>
        </select>
        <button
          @click="initFilter()"
        >
          옵션 초기화
        </button>
      </div>
      <div class="searchinputbox">
        <select v-model="searchFilter"
        id="itemCode"
        >
          <option value="" selected>선택</option>
          <option value="name">리셀러명</option>
          <option value="cNo">사업자등록번호</option>
          <option value="adminName">관리자명</option>
          <option value="uesrname">관리자 ID</option>
        </select>
          <input
          type="text"
          placeholder="조건을 입력해주세요."
          v-model="condition"
          ref="cdInput"
          id=""
          autocomplete="off"
          :readonly="!isFocused"
          @focus="isFocused = true"
          @keyup.enter="enter()"
          />
          <div class="searchBtn">
            <img
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="enter()"
            />
          </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select class="search-select" v-model="rowsPerPage" @change="handleRowsPerPage">
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>

    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination
        :page-info="paginationData"
        page-name="ResellerManage"
        @change-page="paginationHandler"
      />
    </div>
    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="deleteyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>리셀러 삭제</h4>
              <h6>해당 리셀러를 삭제하시겠습니까?</h6>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 2rem">
              <button
                style="margin-right: 1vw;"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
              취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="deleteReseller()"
              >
              삭제
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ResellerInfoW @reload="reloadList"/>
  <ResellerInfoM :data="resellerDetailData" @reload="reloadList"/>

  <!-- 목록 행 「지원 접속」 창(10-29) -->
  <support-entry-dialog
    v-model:open="supportOpen"
    :company-id="supportTarget.id"
    :company-type="supportTarget.type"
    :company-name="supportTarget.name"
  />
</template>
<script>
import supportEntryMixin from "@/mixins/supportEntryMixin";
import {
  openDialog,
  businessNumberFormatter,
  phoneNumberFormatter,
  addCommaToNumber,
  convertDateTime,
} from "../../utils/utils";
import ResellerInfoW from "../components/ResellerInfoW.vue";
import ResellerInfoM from "../components/ResellerInfoM.vue";
import Pagination from "@/views/components/Pagination.vue";
import {
  YnEnum
} from '@/enums/common.enums'

export default {
  mixins: [supportEntryMixin],
  name: "resellerManage",
  components: {
    ResellerInfoW,
    ResellerInfoM,
    Pagination,
  },
  data() {
    return {
      addCommaToNumber,
      type: "RESELLER",
      // 목록 받아오는 변수
      responseData: [],

      selectedReseller: "", // 선택한 리셀러 id
      selectedManager: "", // 선택한 관리자 id
      resellerDetailData: {}, // 상세 정보
      isFocused: false,

      // 필터용 데이터
      deleteFilter: "", // 삭제 여부
      searchFilter: "", // 필터 종류
      previousCondition: "", // 검색어
      condition: "", // 검색어
      listSize: 0,
      rowsPerPage: 10,
      paginationData: {
        currentPage: 1,
        totalPages: 0,
      },
      columns: [
        {key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: 80},
        {key: 'name', title: '리셀러명', dataIndex: 'name', align: 'center'},
        {key: 'cNo', title: '사업자등록번호', dataIndex: 'cNo', align: 'center',
          customRender: ({record}) => {
            return this.businessNumberFormatter(record.cNo)
          }
        },
        {key: 'managedCount', title: '관리 대상 수', dataIndex: 'managedCount', align: 'center',
          customRender: ({record}) => {
            return record.managedCount || 0
          }
        },
        {key: 'createAt', title: '생성 일시', dataIndex: 'createAt', align: 'center',
          customRender: ({record}) => {
            return this.convertDateTime(record.createAt)
          }
        },
        {key: 'isTestCompany', title: '테스트 여부', dataIndex: 'isTestCompany', align: 'center',
          customRender: ({record}) => {
            return record.isTestCompany === YnEnum.Y ? '예' : '아니오'
          }
        },
        {key: 'accountInfo_name', title: '관리자명', dataIndex: 'accountInfo_name', align: 'center'},
        {key: 'accountInfo_mobile', title: '연락처', dataIndex: 'accountInfo_mobile', align: 'center'},
        {key: 'accountInfo_username', title: '관리자 아이디', dataIndex: 'accountInfo_username', align: 'center'},
        {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          width: 150,
          customRender: ({ record }) => {
            if(record.deleteYn === 'N') {
              return <div
                    style="display: flex; gap: 8px; justify-content: center;"
                  >
                  {this.canSupportEntry && (
                    <div
                      type="button"
                      class="certi-custom-btn"
                      onClick={() => {
                        this.openSupport(record, "RESELLER");
                      }}
                    >
                      지원 접속
                    </div>
                  )}
                  <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#resellerInfoMModal"
                    class="certi-custom-btn"
                    onClick={() => {this.getResellerDetail(record._id)}}
                    >
                    수정
                  </div>
                    <div
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteyesno"
                    class="certi-custom-btn"
                    onClick={() => {this.selectReseller(record)}}
                    >
                    삭제
                  </div>
                </div>
            } else {
              return <div style="color: red !important;">삭제됨</div>
            }
          }
        },
      ],
    };
  },

  async mounted() {
    this.isFocused = false;
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  methods: {
    businessNumberFormatter,
    phoneNumberFormatter,
    convertDateTime,
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getResellerList();
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },

    // 리셀러 목록 전체
    async getResellerList() {
      const obj = {};
      if(this.previousCondition !== this.condition) {
        obj.page = 1;
      } else {
        obj.page = this.paginationData.currentPage;
      }
      obj.limit = this.rowsPerPage;
      obj.type = this.type;
      if(this.deleteFilter) obj.deleteYn = this.deleteFilter;
      if(this.searchFilter) obj.search = this.searchFilter;
      if(this.condition) obj.condition = this.condition;

      try {
        const response = await this.$apiInstance.post(`/companies/list/v2`, obj);
        if(response.status === 200 || response.status === 201) {
          if(this.previousCondition !== this.condition) {
            this.paginationData.currentPage = 1;
          }
          this.previousCondition = this.condition;

          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;

          for (let i = 0; i < this.responseData.length; i++) {
            const item = this.responseData[i];
            item.index =
            this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
          this.paginationData.totalPages = response.data.totalPages;
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 리셀러 정보 상세
    async getResellerDetail(id) {
      try {
        const response = await this.$apiInstance.get(`/companies/${id}`);
        if(response.status === 200 || response.status === 201) {
          this.resellerDetailData = response.data;
          this.resellerDetailData.isTestCompany = response.data.isTestCompany === YnEnum.Y;
          this.resellerDetailData.resellerId = id;
        }
      } catch(error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getResellerList();
    },

    // 리셀러 정보 삭제
    async deleteReseller() {
      try {
        const response = await this.$apiInstance.delete(
          `/companies/${this.selectedReseller}`,
        )
        if(response.status === 200 || response.status === 201) {
          await openDialog("해당 리셀러 정보가 삭제되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } else {
          await openDialog("리셀러 정보 삭제에 실패하였습니다.", "error", "확인");
        }
      } catch(error) {
        console.log(error);
        await openDialog("리셀러 정보 삭제에 실패하였습니다.", "error", "확인");
      }
    },

    // 엔터 눌렀을 때 실행
    async enter() {
        this.paginationData.currentPage = 1;
        this.getResellerList();
    },

    // 필터 초기화
    initFilter() {
      this.paginationData.currentPage = 1;
      this.deleteFilter = "";
      this.searchFilter = "";
      this.condition = "";
      this.getResellerList();
    },

    // 수정, 삭제 시 선택
    selectReseller(reseller) {
      this.selectedReseller = reseller._id;
      this.selectedManager = reseller.accountInfo_id;
    },

    reloadList() {
      this.getResellerList();
    },
  },
};
</script>
